import * as XLSX from "xlsx";

export function downloadBroadcastUploadTemplateXLSX(): void {
  // Define the header row with exact column names
  const headers = [
    "Category",
    "Manufacturer",
    "SKU / Model / Part Number",
    "Quantity",
    "Condition",
    "Price",
    "Description",
  ];

  // Create a new workbook
  const wb = XLSX.utils.book_new();

  // Create worksheet with headers only (no data rows)
  const ws = XLSX.utils.aoa_to_sheet([headers]);

  // Set column widths for better readability
  const columnWidths = [
    { wch: 15 }, // Category
    { wch: 15 }, // Manufacturer
    { wch: 25 }, // SKU / Model / Part Number
    { wch: 10 }, // Quantity
    { wch: 15 }, // Condition
    { wch: 10 }, // Price
    { wch: 30 }, // Description
  ];
  ws["!cols"] = columnWidths;

  // Add worksheet to workbook with specific name
  XLSX.utils.book_append_sheet(wb, ws, "BroadcastUpload");

  // Download the file
  XLSX.writeFile(wb, "broadcast-upload-template.xlsx");
}
